import React from 'react'
import { useIsTablet } from '../useIsTablet'
import { useTranslation } from 'utils/useTranslation'

export function FilterHeaderMobile({ showFilters, setShowFilters, setIsModelFilterOpen, setIsCategoryFilterOpen }) {
  const accessoryStrings = useTranslation('accessories_shop.misc') ?? {}
  if (!useIsTablet()) {
    return null
  }

  const handleOnClick = () => {
    const newShowFilters = !showFilters
    setShowFilters(newShowFilters)
    if (!newShowFilters) {
      setIsModelFilterOpen(false)
      setIsCategoryFilterOpen(false)
    }
  }

  return (
    <div className='mtt-filter__header-mobile'>
      <h4>{accessoryStrings.accessory}</h4>
      <div className='mtt-filter__header-filter-btn' onClick={() => handleOnClick()}>
        <span>{accessoryStrings.filter}</span>
      </div>
    </div>
  )
}
